module.exports = __webpack_public_path__ + "static/media/value-absolute.676a10d7.svg";